let bbPop = (() => {

  const settings = {
    // Popup element selectors
    popup: document.querySelector('div.bbpop'),
    prodImg: document.querySelector('#bbpop-img'),
    imgLink: document.querySelector('#bbpop-img-link'),
    description: document.querySelector('#bbpop-description'),
    timeMsg: document.querySelector('#bbpop-time-msg'),

    // Popup timer settings
    firstInterval: 6, // seconds
    minInterval: 20, // seconds
    maxInterval: 45, // seconds
    maxPops: 3, // per page

    // Other settings
    phoneWidth: 600,
    apiURL: 'https://us-central1-bbpop-34f6d.cloudfunctions.net/events'
  };

  let hidePop =
    document.cookie.split(';').some(item => item.trim().startsWith('bbPopHide=true'));

  const isPhone = () => window.innerWidth <= settings.phoneWidth;

  const getEvents = async () => {
    try {
      const response = await fetch(settings.apiURL);
      if (!response.ok) throw new Error(response.statusText);
      return await response.json();
    } catch (error) {
      console.error('[bbPop] Could not fetch events', error);
      return [];
    }
  };

  const storeEvents = (eventArray) => {
    if (Array.isArray(eventArray) && eventArray.length > 0) {
      sessionStorage.setItem('bbevents', JSON.stringify(eventArray));
    }
  };

  const prettyTime = (ms) => {
    let mins = Math.floor(ms / 60000);
    if (mins === 0) mins = 1;

    if (mins < 60) {
      return mins === 1 ? '1 minute ago' : `${mins} minutes ago`;
    }

    let hours = Math.floor(mins / 60);
    return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
  };

  const nextEvent = () => {
    const stored = sessionStorage.getItem('bbevents');
    if (!stored) return null;

    let eventsArr = JSON.parse(stored);
    if (!eventsArr.length) {
      sessionStorage.removeItem('bbevents');
      return null;
    }

    let nextEventData = eventsArr.shift();
    if (eventsArr.length > 0) {
      sessionStorage.setItem('bbevents', JSON.stringify(eventsArr));
    } else {
      sessionStorage.removeItem('bbevents');
    }
    return nextEventData;
  };

  const buildPopup = () => {
    const eventItem = nextEvent();
    if (!eventItem) return;

    const url = '/products/' + eventItem.handle;
    const img = eventItem.img;
    const title = eventItem.title;
    const city = eventItem.city;
    const timestamp = eventItem.timestamp;
    const timeDiff = Date.now() - timestamp;

    if (!settings.popup) return;

    settings.prodImg.setAttribute('src', img);
    settings.prodImg.setAttribute('alt', title);
    settings.imgLink.href = url;
    settings.timeMsg.textContent = prettyTime(timeDiff);
    settings.description.innerHTML = `Someone in ${city} bought <a href="${url}" title="${title}">${title}</a>`;
  };

  // Controls popup slide up, pause, slide down animation
  const delayedClassToggle = (element, cssClass, duration) => {
    if (!element) return;
    element.classList.add(cssClass);
    setTimeout(() => element.classList.remove(cssClass), duration);
  };

  const showPopup = () => {
    buildPopup();
    delayedClassToggle(settings.popup, 'bbpop-slide', 6500);
  };

  // Create random number for popup interval duration
  const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max + 1);
    return Math.floor(Math.random() * (max - min)) + min;
  };

  // Fires popups after [firstInterval], then at random intervals
  const queuePops = () => {
    let firstInterval = settings.firstInterval;
    let minInterval = settings.minInterval;
    let maxInterval = settings.maxInterval;
    let popCount = settings.maxPops;

    const nextPop = () => {
      showPopup();
      popCount--;
    };

    setTimeout(() => {
      nextPop();
      const popTimer = () => {
        if (popCount > 0 && sessionStorage.getItem('bbevents') && !hidePop) {
          setTimeout(() => {
            if (hidePop) return;
            nextPop();
            popTimer();
          }, getRandomInt(minInterval, maxInterval) * 1000);
        }
      };
      popTimer();
    }, firstInterval * 1000);
  };

  return {
    init: async () => {
      if (hidePop) return;
      if (isPhone()) return;
      try {
        if (!sessionStorage.getItem('bbevents')) {
          let eventArray = await getEvents();
          storeEvents(eventArray);
        }
        if (sessionStorage.getItem('bbevents')) {
          queuePops();
        }
      } catch (error) {
        console.error('[bbPop] Could not initialise', error);
      }
    },

    hide: (evt, closeBtn) => {
      if (evt.target === closeBtn) {
        if (settings.popup) {
          settings.popup.classList.remove('bbpop-slide');
        }
        document.cookie = 'bbPopHide=true; path=/; max-age=86400';
        hidePop = true;
      }
    }
  };
})();

// Run on window load
window.addEventListener('load', () => {
  bbPop.init();
});

// Wire up close button after DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const closeBtn = document.querySelector('#bbpop-close-svg');
  if (closeBtn) {
    closeBtn.addEventListener('click', evt => bbPop.hide(evt, closeBtn));
  }
});
